<template>
  <div>
    <SquareBanner
      v-if="paymentMethod"
      :base-price
      class="mb-12"
      :payment-method
    />

    <DefaultRedirectionText v-if="paymentGroup" :group="paymentGroup" />

    <slot />
  </div>
</template>

<script lang="ts" setup>
import SquareBanner from '../../../../advertising/components/SquareBanner/SquareBanner.vue'
import type { PaymentFormAdornmentProps } from '../PaymentFormAdornment.type'

import DefaultRedirectionText from './DefaultRedirectionText.vue'

defineProps<PaymentFormAdornmentProps>()
</script>
